import angular from 'angular';
import User from './user/user';
import Auth from './auth/auth';
import dbFactory from './services/loki.factory';
import Api from './services/api';
let commonModule = angular.module('app.common', [
  User,
  Auth
])
  .factory('db', dbFactory)
  .service("Api", Api)
  .name;

export default commonModule;


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/common/common.js
 **/